module.exports = __webpack_public_path__ + "static/media/logo_lamoderna.956abe9a.jpg";